import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import Api from '../../../../../services/Api';
import Button from '../../../../atoms/Button/Button';
import ComponentTypeSelector from '../../../../atoms/ComponentTypeSelector/ComponentTypeSelector';
import Icon from '../../../../atoms/Icon/Icon';
import './CreateComponentModal.scss';

const CreateComponentModal = ({
  onItemCreated,
  cityId,
  dynastyId,
}) => {
  const [typeId, setTypeId] = useState(undefined);
  const [name, setName] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const saveComponent = () => {
    if (!typeId) {
      setError('Component type is required');
      return;
    }
    if (!name) {
      setError('Component name is required');
      return;
    }
    setLoading(true);
    Api.post('instances/building-components', {
      name,
      code_suffix: 'BCN',
      dynasty_id: dynastyId,
      city_id: cityId,
      component_type_id: typeId,
    }).then((response) => {
      setLoading(false);
      onItemCreated(response.data);
    });
  };
  return (
    <Row>
      <Col md={12}>
        <FormGroup>
          <Label>Type</Label>
          <ComponentTypeSelector onChanged={e => setTypeId(e.value)} isMulti={false} />
        </FormGroup>
      </Col>
      <Col md={12}>
        <FormGroup>
          <Label>Name</Label>
          <Input type="text" onChange={e => setName(e.target.value)} value={name} />
        </FormGroup>
      </Col>
      {error !== undefined && (
        <Col md={12} className="d-flex justify-content-end">
          <span className="text-danger">{error}</span>
        </Col>
      )}
      <Col className="d-flex justify-content-end mt-3">
        <Button isLoading={loading} onInvoked={() => saveComponent()}>
          <Icon icon="save" color="#fff" />
          <span className="ms-2">Save</span>
        </Button>
      </Col>
    </Row>
  );
};

CreateComponentModal.propTypes = {
  onItemCreated: PropTypes.func.isRequired,
  cityId: PropTypes.number.isRequired,
  dynastyId: PropTypes.number.isRequired,
};

CreateComponentModal.defaultProps = {

};

export default CreateComponentModal;
